import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

//components
import { DotsLoader } from 'components/common/DotsLoader';

//styles
import { LoaderContainer } from './Loader.styled';

type objectOrArr = object | [];

interface ILoader<T extends objectOrArr> {
  isLoading: boolean;
  // TODO: remove unknown type from isError when we change hooks to tsx
  isError: boolean | unknown;
  data?: T;
  children(data: T): ReactNode;
}

export const Loader = <T extends objectOrArr>({
  isLoading,
  isError,
  data,
  children,
}: ILoader<T>) => {
  if (isLoading) {
    return (
      <LoaderContainer>
        <DotsLoader />
      </LoaderContainer>
    );
  }

  if (isError) {
    return <Navigate to="/500" />;
  }

  if (data === null || data === undefined) {
    return <Navigate to="/404" />;
  }

  return <>{children(data)}</>;
};
